export default "__VITE_ASSET__CibvSwjx__"